import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const { pathname } = useLocation();

  const prefersDark =
    typeof window !== "undefined" &&
    (document.documentElement.classList.contains("dark") ||
      document.body.classList.contains("dark") ||
      window.matchMedia?.("(prefers-color-scheme: dark)")?.matches);

  const isMobile =
    typeof window !== "undefined" &&
    (window.matchMedia?.("(max-width: 520px)")?.matches || window.innerWidth <= 520);

  const styles = {
    root: {
      minHeight: "100dvh",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "clamp(16px, 4vw, 32px)",
      boxSizing: "border-box",
      background:"#396afc"
    },
    card: {
      width: "100%",
      maxWidth: "600px", 
      background:   "#fff",
      border: `1px solid ${
        prefersDark ? "rgba(255,255,255,0.12)" : "rgba(15,23,42,0.08)"
      }`,
      borderRadius: 14,
      padding: isMobile ? "18px" : "28px",
      textAlign: "center",
      boxShadow: prefersDark
        ? "0 10px 30px rgba(0,0,0,0.35)"
        : "0 10px 24px rgba(15,23,42,0.08)",
      boxSizing: "border-box", // fix overflow
      overflowWrap: "break-word", // long text bhi break ho jaye
    },
    code: {
      fontSize: isMobile ? "44px" : "64px",
      margin: 0,
      fontWeight: 800,
    },
    title: {
      margin: "8px 0 6px",
      fontWeight: 700,
      fontSize: isMobile ? "18px" : "20px",
    },
    desc: {
      margin: "0 0 14px",
      color: prefersDark ? "#94a3b8" : "#64748b",
      fontSize: isMobile ? "14px" : "15px",
    },
    actions: {
      display: "flex",
      justifyContent: "center",
      gap: "10px",
      flexWrap: "wrap",
      flexDirection: isMobile ? "column" : "row",
    },
    btn: {
      padding: "10px 14px",
      borderRadius: 10,
      textDecoration: "none",
      fontWeight: 700,
      border: `1px solid   #396afc`,
      width: isMobile ? "100%" : "auto",
      textAlign: "center",
      boxSizing: "border-box",
    },
    btnOutline: { color:"#fff", background: "#396afc", borderColor: "#396afc" },
    btnSolid: { color: "#fff", background: "#2563eb", borderColor: "#2563eb" },
  };

  return (
    <main style={styles.root}>
      <section style={styles.card}>
        <h1 style={styles.code}>404</h1>
        <p style={styles.title}>Page not found</p>
        <p style={styles.desc}>The page you are looking for does not exist.</p>
        <div style={styles.actions}>
          <Link to="/" style={{ ...styles.btn, ...styles.btnOutline }}>
            Go to Landing
          </Link>
        </div>
      </section>
    </main>
  );
}
